export const CANVAS = "canvas";
export const EXTERNAL = "external";
export const QUALITATIVE = "qualitative";
export const EMBEDDED = "embedded";

export const emailVerification = (email) => {
  if (/\S+@\S+\.\S+/.test(email)) {
    return true;
  } else {
    return false;
  }
};

export function emailMatches(emailA, emailB) {
  const normalizedA =
    typeof emailA === "string" ? emailA.trim().toLowerCase() : "";
  const normalizedB =
    typeof emailB === "string" ? emailB.trim().toLowerCase() : "";
  // If either email is missing or empty after normalization, do not treat as a match
  if (!normalizedA || !normalizedB) {
    return false;
  }
  return normalizedA === normalizedB;
}

export function emailIsInList(existingEmails, newEmail) {
  return existingEmails.some((email) => emailMatches(email, newEmail));
}

export const evidenceFileTypes = [
  // Spreadsheets
  ".csv",
  ".xls",
  ".xlsx",
  // Text Files
  ".txt",
  ".pdf",
  ".doc",
  ".docx",
  // Images
  ".jpg",
  ".jpeg",
  ".png",
  // Audio
  ".mp3",
  ".wav",
  ".ogg",
  ".m4a",
  // Video
  ".mp4",
  ".mov",
  // Zip
  ".zip",
];
